module.exports = __webpack_public_path__ + "img/ja.8608025c.svg";